export const ACTION_TYPE = 'fonts/LOAD';
